// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"AddAttendance_AssignChecklist__-wIxE","modalBody":"AddAttendance_modalBody__tpR6E","formControl":"AddAttendance_formControl__w7bLU"};